export default __webpack_public_path__ + "static/media/amministrazione.6d5be244.jpg";